import { Component } from "react";
import { withRouter } from "react-router-dom";

/**
 * Renders nothing. Scrolls the window back to the top whenever the route
 * changes, so every page opens at its top instead of keeping the previous
 * page's scroll position. Sits inside the Router in App.js, above the Switch,
 * like SessionValidityWatcher.
 */
class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return null;
    }
}

export default withRouter(ScrollToTop);
